import { render } from "./VacunaMarc.vue?vue&type=template&id=b9d7268c&scoped=true"
import script from "./VacunaMarc.vue?vue&type=script&lang=js"
export * from "./VacunaMarc.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=b9d7268c&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9d7268c"]])

export default __exports__